import React from 'react';
import { Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function IdCardIndicator({ hasIdCard }) {
  return hasIdCard ? (
    <Tooltip title="มีเลขบัตรประชาชนในระบบ">
      <CheckCircleIcon fontSize="small" color="success" sx={{ verticalAlign: 'middle', mr: 0.5, flexShrink: 0 }} />
    </Tooltip>
  ) : (
    <Tooltip title="ไม่มีเลขบัตรประชาชนในระบบ">
      <CancelIcon fontSize="small" color="error" sx={{ verticalAlign: 'middle', mr: 0.5, flexShrink: 0 }} />
    </Tooltip>
  );
}
